import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import {
  Wrapper,
  WrapperData,
  ContactProfileTheme,
  ContactInfoNoteTheme,
  ContactInfoActivityTimelineTheme,
  Button,
  DropdownToggle,
} from 'modules/theme';
import { Alert } from 'modules/theme';
import { Icon } from 'modules/common/components';
import APIManager from 'modules/common/apiManager';
import { Col, Dropdown, Row } from 'react-bootstrap';

export class ContactPrivateInfo extends Component {
  constructor(props) {
    super(props);
    this.mAPI = new APIManager();
    let custInfo = props.custInfo || {};

    this.rejectList = [
      '_id',
      'phone_number',
      'publicInfo',
      'updateBy',
      'update_at',
      'listId',
      'listName',
    ];

    this.state = {
      custInfo: {},
      comments: props.comments || [],
      contactInfoId: props.contactInfoId || '',
      contactId: props.contactId || '',
      loading: false,
      listData: custInfo.info,
      listDataa: custInfo.objInfo,
      listField:
        custInfo.objInfo && custInfo.objInfo.fields
          ? custInfo.objInfo.fields
          : [],
      contactInformation: [],
    };
    this.getList = this.getList.bind(this);
    this.getReports = this.getReports.bind(this);
    // this.getList();
  }
  componentWillReceiveProps(nextProps, prevState) {
    try {
      if (nextProps.custInfo) {
        let currentJson = JSON.stringify(nextProps.custInfo);
        let prevJson = JSON.stringify(prevState.custInfo);
        if (currentJson !== prevJson) {
          let custInfo = nextProps.custInfo;
          this.setState({
            custInfo: custInfo,
            listData: custInfo.info,
            listDataa: custInfo.objInfo,
            listField:
              custInfo.objInfo && custInfo.objInfo.fields
                ? custInfo.objInfo.fields
                : [],
          });
        }
      }
      if (nextProps.comments) {
        let currentComments = JSON.stringify(nextProps.comments);
        let prevComments = JSON.stringify(prevState.comments);
        if (currentComments !== prevComments) {
          let comments = nextProps.comments;
          this.setState({
            comments: comments,
          });
          //
        }
      }
    } catch (error) { }
    // this.setState(nextProps);
  }

  async componentDidMount() {
    if (this.state.contactInfoId) {
      await this.getList(this.state.contactInfoId, this.state.contactId);
      this.getReports();
    }
  }

  getList(contactInfoId = '', contactId = '') {
    var that = this;
    this.setState({ loading: true });

    return new Promise((res, rej) => {
      if (contactInfoId != '') {
        this.mAPI.sendGetAPI(
          `contact/contact-list/mobileNo/detail?contactListId=${contactId}&mobileNumber=${contactInfoId}`,
          (data) => {
            this.setState({ loading: false });
            if (data) {
              that.setState({ listData: data.info });
              that.setState({ listDataa: data.objInfo });
              that.setState({ listField: data.objInfo.fields });
              that.setState({ custInfo: data });
              res();

              // let listName = data.objInfo.name || "";
              // that.setState({ listField: data.objInfo.fields, listName: listName });
              // data.objInfo.map(td => {
              //
              //   that.setState({ listField: td.fields });
              // });
            }
          },
          (error, data) => {
            that.setState({ loading: false, listData: [] });

            if (data) {
              Alert.error(` ${data.message}`);
            } else {
              Alert.error(`${error}`);
            }
            rej();
          }
        );
      } else {
        that.setState({ loading: false, listData: [] });
        rej();
      }
    });
  }

  getReports() {
    this.mAPI.sendPostAPI(
      'voice-cdr-report/list',
      {
        filter: {
          to: this.state.listData && this.state.listData.phone_number,
          endDate: '',
          sendEndTime: '',
          sendStartTime: '',
          startDate: '',
        },
        limit: 10,
        listConfig: {},
        order: '',
        orderBy: '',
        page_no: 1,
        subType: 'voice-report',
        type: 'voice',
      },
      (data) => {
        if (data && data.data) {
          // ALREADY PROCESSED DATA

          // let tempList = {};
          /* for (let item of data.data) {
            let [date, time] = item.date.split(" ");

            if (tempList && !(date in tempList)) {
              tempList[date] = [];
            }

            let { agentName, callingMode, comment, tag } = item;
            tempList[date].push({
              CallType: "Something here...",
              Date: date,
              agentName,
              callingMode,
              comment,
              phoneNumber:
                this.state.listData && this.state.listData.phone_number,
              tags: tag,
              time,
            });
          } */

          // UNPROCESSED WHICH WILL BE PROCESSED IN CONTACTINFOACTIVITYTIMELINETHEME

          let tempList = data.data.map((entry) => {
            const {
              date: dateTime,
              agentName,
              callingMode,
              comment,
              tag: tags,
            } = entry;

            const [dateString, rawTime] = dateTime.split(' ');
            const timeParts = rawTime.split(':');
            const hours = parseInt(timeParts[0]);
            const minutes = parseInt(timeParts[1]);
            const seconds = parseInt(timeParts[2]);

            const date = new Date();
            date.setHours(hours);
            date.setMinutes(minutes);
            date.setSeconds(seconds);

            const time = date
              .toLocaleTimeString([], {
                hour: 'numeric',
                minute: '2-digit',
                hour12: true,
              })
              .toUpperCase();

            const phoneNumber =
              this.state.listData && this.state.listData.phone_number;
            return {
              CallType: '-',
              Date: dateString,
              agentName,
              callingMode,
              comment,
              phoneNumber,
              tags,
              time,
            };
          });
          this.setState({ contactInformation: tempList });
        }
      },
      (errorCode, data) => {
        if (data && data.message) {
          Alert.error(` ${data.message}`);
        } else {
          Alert.error('Something Went Wrong');
        }
      },
      'private',
      {}
    );
  }

  renderActionBar() {
    const { __ } = this.context;
    return (
      <span>
        <Dropdown id='dropdown-engage' pullRight>
          <DropdownToggle bsRole='toggle'>
            <Button btnStyle='default' size='small'>
              Actions <Icon icon='downarrow-2' />
            </Button>
          </DropdownToggle>
          <Dropdown.Menu>
            <li>
              <a>{__('Edit')}</a>
            </li>
            <li>
              <a
              // onClick={e =>
              //     confirm().then(e => {
              //         this.deleteSound();
              //     })
              // }
              >
                {__('Delete')}
              </a>
            </li>
          </Dropdown.Menu>
        </Dropdown>
      </span>
    );
  }

  render() {
    const { __ } = this.context;
    const breadcrumb = [
      { title: __('Settings'), link: '/settings' },
      { title: __('Contact List'), link: '/settings/Contact-List' },
      {
        title: __('Contact'),
        link: `/settings/Contact-List-Private?id=${this.props.contactId}`,
      },
      {
        title: __('Contact Details'),
        link: '/settings/contact/contact-details',
      },
    ];

    const mainContent = (
      <Row>
        <Col
          md={3}
          style={{ borderRight: '1px solid #ddd', paddingRight: '0px' }}
        >
          <ContactProfileTheme
            custInfo={this.state.custInfo}
            listData={this.state.listData}
            listDataa={this.state.listDataa}
            listField={this.state.listField}
            getList={this.getList}
          />
        </Col>
        <Col md={9} style={{ borderRight: '1px solid #ddd', padding: '0px' }}>
          <ContactInfoActivityTimelineTheme
            comments={this.state.contactInformation}
          />
          {/* <ContactInfoNoteTheme />
                    <ContactInfoActivityTheme /> */}
        </Col>
        {/* <Col md={3} style={{ paddingLeft: "0px" }}>
					<ContactInfoNoteTheme />
				</Col> */}
      </Row>
    );

    return (
      // <DataWrapperClass>

      <WrapperData
        header={<Wrapper.Header breadcrumb={breadcrumb} />}
        content={mainContent}
        transparent={false}
      />
      // </DataWrapperClass>
    );
  }
}

ContactPrivateInfo.contextTypes = {
  __: PropTypes.func,
};

export default withRouter(ContactPrivateInfo);



// WEBPACK FOOTER //
// src/modules/screens/settings/ContactDetails/components/ContactDetails.jsx